import { gql } from '@apollo/client';
import { PROJECT_LESS_FIELDS_FRAGMENT, PLANNING_PROJECT_LESS_FIELDS_FRAGMENT } from './project';
import {
    USER_EPIC_ROLE_TYPE_FRAGMENT,
    USER_FIELDS_FRAGMENT,
    USER_PROJECT_ROLE_TYPE_FRAGMENT,
    USER_WORKPACKAGE_ROLE_TYPE_FRAGMENT
} from './user';

export const PLANNING_WORKPACKAGE_FIELDS_FRAGMENT = gql`
    fragment PlanningWorkPackageFields on WorkPackage {
        WorkPackageId
        WorkName
        WorkNbr
        Created
        Updated
        Target
        StartDate
        EndDate
        WorkPackageStatus {
            WorkPackageStatusId
            Name
        }
        Project {
            ...PlanningProjectLessFields
        }
        Epic {
            Name
            EpicId
            EpicNbr
            DataOwner
            Secret
            CoordinateSystemType {
                DatumCode
                Name
                CoordinateSystemTypeId
            }
            HeightSystemType {
                Name
                HeightSystemTypeId
            }
        }
        Access {
            Read
            Create
            Delete
            Update
        }
    }
    ${PLANNING_PROJECT_LESS_FIELDS_FRAGMENT}
`;

export const WORKPACKAGE_FIELDS_FRAGMENT = gql`
    fragment WorkPackageFields on WorkPackage {
        WorkPackageId
        WorkName
        WorkNbr
        Created
        Updated
        Target
        StartDate
        EndDate
        WorkPackageStatus {
            WorkPackageStatusId
            Name
        }
        Project {
            ...ProjectLessFields
        }
        Tasks {
            TaskId
            Location {
                LocationId
            }
        }
        Epic {
            Name
            EpicId
            EpicNbr
            DataOwner
            Secret
            CoordinateSystemType {
                DatumCode
                Name
                CoordinateSystemTypeId
            }
            HeightSystemType {
                Name
                HeightSystemTypeId
            }
        }
        Access {
            Read
            Create
            Delete
            Update
        }
        Cables
        Pipes
        Lines
        LocationMoveAllowedAtObstacles
        MaxLocationMove
        AgreeLocationMoveWithDesigner
        TaskTypeInstruction {
            TaskTypeInstructionId
            WorkPackage {
                WorkPackageId
            }
            Instruction
            TaskType {
                ...BasicTaskTypeFields
            }
        }
        WorkPackageUsers {
            User {
                UserState
                Firstname
                Lastname
                Phone
                Email
                UserId
                OwnOrganization {
                    OrganizationId
                    Name
                }
            }
            AccessUserType {
                ... on UserWorkPackageRoleType {
                    UserWorkPackageRoleTypeId
                    Name
                }
            }
        }
    }
    ${PROJECT_LESS_FIELDS_FRAGMENT}
`;

export const WORKPACKAGE_SUMMARY_FIELDS_FRAGMENT = gql`
    fragment WorkPackageSummaryFields on WorkPackageSummary {
        TaskSummary {
            TaskStatus {
                TaskStatusId
                Name
            }
            TaskType {
                TaskTypeId
                Name
                Abbr
                TaskGroup
            }
            Open
            Assigned
            Resourced
            Ongoing
            Done
            Cancelled
            Failed
            Paused
            Total
        }
        TaskDone
        TaskTotal
    }
`;

export const WORKPACKAGE_USER_FIELDS_FRAGMENT = gql`
    fragment WorkPackageUserFields on WorkPackage {
        WorkPackageId
        WorkPackageUsers {
            User {
                ...UserFields
            }
            AccessUserType {
                __typename
                ... on UserWorkPackageRoleType {
                    ...UserWorkPackageRoleTypeFields
                }
                ... on UserProjectRoleType {
                    ...UserProjectRoleTypeFields
                }
                ... on UserEpicRoleType {
                    ...UserEpicRoleTypeFields
                }
            }
        }
    }
    ${USER_FIELDS_FRAGMENT}
    ${USER_WORKPACKAGE_ROLE_TYPE_FRAGMENT}
    ${USER_PROJECT_ROLE_TYPE_FRAGMENT}
    ${USER_EPIC_ROLE_TYPE_FRAGMENT}
`;
